import styled from "styled-components/macro";
import { THEME_COLOR, THEME_COLOR_DARK } from "../vars";

const HtmlFormat = styled.div`
  h2 {
    font-size: 1.1em;
    margin: 1em 0;
    margin-top: 0;
    &:not(:first-child) {
      margin-top: 2em;
    }
    font-weight: bold;
    color: ${THEME_COLOR_DARK};
  }
  h3 {
    font-size: 1.1em;
    margin: 1em 0;
    margin-top: 0;
    &:not(:first-child) {
      margin-top: 2em;
    }
    font-weight: bold;
    color: ${THEME_COLOR_DARK};
  }
  p {
    margin-bottom: 1em;
    line-height: 1.5em;
  }
  img {
    max-width: 100%;
    margin: 1em 0;
  }

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  a {
    background-color: transparent;
  }

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  ul {
    list-style-type: disc;
    list-style-position: outside;
    margin-bottom: 1em;
  }
  ol {
    list-style-type: decimal;
    list-style-position: outside;
    margin-bottom: 1em;
  }
  ul ul,
  ol ul {
    list-style-type: circle;
    list-style-position: outside;

    margin-left: 15px;
  }
  ol ol,
  ul ol {
    list-style-type: lower-latin;
    list-style-position: outside;

    margin-left: 15px;
  }
  li {
    margin-left: 2em;
    line-height: 1.5em;
  }
  a:visited {
    color: ${THEME_COLOR};
  }
  a:link {
    color: ${THEME_COLOR};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  u {
    text-decoration: underline;
  }
  em,
  i {
    font-style: italic;
  }
`;

export default HtmlFormat;
